<template>
  <v-text-field
    :id="inputId"
    :label="inputLabel"
    v-model="valorInterno"
    :disabled="campoDesabilitado"
    :required="campoObrigatorio"
    :rules="[rules.requiredTime, rules.alfanumerico]"
    :counter="maxCaracteres"
    :maxlength="maxCaracteres"
    @input="emiteValorAlterado"
  ></v-text-field>
</template>
<script>
import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoTexto',
  props: {
    value: {
      type: [String],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    maxCaracteres() {
      const { desAtributos } = this.metadados;
      if (!desAtributos) return null;
      return desAtributos.max;
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredTime: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.valorInterno ? this.valorInterno.trim() : null;
          return !!(val) || msg;
        },
        alfanumerico: () => {
          const atributos = this.metadados && this.metadados.desAtributos;
          if (!atributos || !atributos.alfanumerico) {
            return true;
          }
          const val = this.valorInterno ? String(this.valorInterno).trim() : '';
          if (!val) {
            return true;
          }
          return /[0-9A-Za-z]/.test(val) || this.$t('message.formato_invalido_alfanumerico');
        },
      },
    };
  },
};
</script>
